import { createAction, props } from '@ngrx/store';
import {
  IpExclusion,
  IpExclusionsListMeta,
  IpExclusionStatistics,
  IpExclusionSubmitPayload,
} from '../models/ip-exclusion.model';
import { ApiTableFilter } from '../../../shared/models/table-filter.model';

// ---- List ----
export const loadIpExclusions = createAction(
  '[IP Exclusions] Load IP Exclusions',
  props<{
    page?: number;
    perPage?: number;
    search?: string;
    sort?: string;
    sortDirection?: string;
    filters?: ApiTableFilter[];
    filterLink?: string;
  }>()
);
export const loadIpExclusionsSuccess = createAction(
  '[IP Exclusions] Load IP Exclusions Success',
  props<{ ipExclusions: IpExclusion[]; meta: IpExclusionsListMeta }>()
);
export const loadIpExclusionsFailure = createAction(
  '[IP Exclusions] Load IP Exclusions Failure',
  props<{ error: string }>()
);

// ---- Statistics ----
export const loadIpExclusionStatistics = createAction(
  '[IP Exclusions] Load Statistics'
);
export const loadIpExclusionStatisticsSuccess = createAction(
  '[IP Exclusions] Load Statistics Success',
  props<{ statistics: IpExclusionStatistics }>()
);
export const loadIpExclusionStatisticsFailure = createAction(
  '[IP Exclusions] Load Statistics Failure',
  props<{ error: string }>()
);

// ---- Submit (create/edit) ----
export const submitIpExclusion = createAction(
  '[IP Exclusions] Submit IP Exclusion',
  props<{ payload: IpExclusionSubmitPayload; isEditMode: boolean }>()
);
export const submitIpExclusionSuccess = createAction(
  '[IP Exclusions] Submit IP Exclusion Success'
);
/** `duplicate` carries the uuid of the existing exclusion when the IP already exists. */
export const submitIpExclusionDuplicate = createAction(
  '[IP Exclusions] Submit IP Exclusion Duplicate',
  props<{ duplicate: string }>()
);
export const submitIpExclusionFailure = createAction(
  '[IP Exclusions] Submit IP Exclusion Failure',
  props<{ error: string }>()
);

// ---- Delete (single) ----
export const deleteIpExclusion = createAction(
  '[IP Exclusions] Delete IP Exclusion',
  props<{ uuid: string }>()
);
export const deleteIpExclusionSuccess = createAction(
  '[IP Exclusions] Delete IP Exclusion Success'
);
export const deleteIpExclusionFailure = createAction(
  '[IP Exclusions] Delete IP Exclusion Failure',
  props<{ error: string }>()
);

// ---- Bulk delete ----
export const bulkDeleteIpExclusions = createAction(
  '[IP Exclusions] Bulk Delete IP Exclusions',
  props<{ uuids: string[]; allSelected: boolean }>()
);
export const bulkDeleteIpExclusionsSuccess = createAction(
  '[IP Exclusions] Bulk Delete IP Exclusions Success'
);
export const bulkDeleteIpExclusionsFailure = createAction(
  '[IP Exclusions] Bulk Delete IP Exclusions Failure',
  props<{ error: string }>()
);

// ---- Get by id (view a duplicate/original) ----
export const loadIpExclusionById = createAction(
  '[IP Exclusions] Load IP Exclusion By Id',
  props<{ uuid: string }>()
);
export const loadIpExclusionByIdSuccess = createAction(
  '[IP Exclusions] Load IP Exclusion By Id Success',
  props<{ ipExclusion: IpExclusion }>()
);
export const loadIpExclusionByIdFailure = createAction(
  '[IP Exclusions] Load IP Exclusion By Id Failure',
  props<{ error: string }>()
);
export const clearSingleIpExclusion = createAction(
  '[IP Exclusions] Clear Single IP Exclusion'
);

// ---- Import ----
export const importIpExclusions = createAction(
  '[IP Exclusions] Import CSV',
  props<{ formData: FormData }>()
);
export const importIpExclusionsSuccess = createAction(
  '[IP Exclusions] Import CSV Success'
);
export const importIpExclusionsFailure = createAction(
  '[IP Exclusions] Import CSV Failure',
  props<{ error: string }>()
);

export const resetIpExclusionsState = createAction('[IP Exclusions] Reset State');
